<agr-dialog [data]="data" (alt)="alt()" (cancel)="cancel()" (confirm)="confirm()">
  <p>
    {{ 'cart.return-date-help-modal.description' | translate }}
  </p>
</agr-dialog>
